import { createStyles, makeStyles } from '@material-ui/core/styles';
export var useStyles = makeStyles(function (theme) { return createStyles({
    container: {
        marginLeft: theme.spacing(2),
        width: 'auto',
        maxWidth: 350,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    info: {
        padding: '15px',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        backgroundColor: theme.palette.background.default,
    },
    name: {
        fontSize: '13px',
        fontWeight: 'bold',
    },
    email: {
        fontSize: '11px',
        fontWeight: 'bold',
        color: '#949494',
        display: 'block',
    },
}); });
//# sourceMappingURL=profileBoxStyles.js.map